var teamInviteMap = {
  id: 'id',
  token: 'token',
  type: 'type',
  emailAddress: 'emailAddress',
  teamId: 'teamId',
  accepted: 'accepted',
  dateCreated: 'dateCreated',
  dateModified: 'dateModified',
  acceptedResourceId: 'acceptedResourceId'
};
export default teamInviteMap;